import { atom } from 'jotai';

import { DEFAULT_INTEGRATION_FORM } from '@/src/modules/IntegrationsModule/constants';
import { CreateOrEditIntegrationForm } from '@/src/modules/IntegrationsModule/hooks/CreateOrEditIntegration/useCreateOrEditIntegrationForm';

export const atomCreateOrEditIntegrationForm =
  atom<CreateOrEditIntegrationForm>(DEFAULT_INTEGRATION_FORM);

export const atomCurrentStep = atom(1);
export const atomStepCompleted = atom(0);
